import * as React from 'react';

import { Column } from '../../../common/Column';

interface ILayoutProps extends React.PropsWithChildren {
  columnCount?: number;
}

export const Layout: React.FC<ILayoutProps> = ({ children, columnCount = 3 }) => {
  const childrenArray = React.Children.toArray(children) as JSX.Element[];
  const columns = childrenArray.reduce(
    (acc, item, index) => {
      const i = index % columnCount;

      acc[i].push(item);

      return acc;
    },
    Array.from({ length: columnCount }, (): JSX.Element[] => []),
  );

  return (
    <>
      {columns.map((column, index: number) => (
        <Column key={`column_${index}`}>{column.map(child => React.cloneElement(child))}</Column>
      ))}
    </>
  );
};
